import { type StyleProp, type ViewStyle } from "react-native"
import { H5, Small } from "@/components/standard/BFText"
import { useLoanContext } from "@/screens/loans/components/LoanContext"
import { cn } from "@/components/util/cn"
import { Vertical } from "@/components/standard/BFLayout"

export const LoanAddressHeader = ({
  className,
  style,
  address,
}: {
  className?: string
  style?: StyleProp<ViewStyle>
  address?: {
    street?: string | null
    city?: string | null
    state?: string | null
    zipcode?: string | null
  }
}) => {
  const { loanApplication } = useLoanContext()

  if (!loanApplication && !address) {
    return null
  }

  const streetAddress = address?.street || loanApplication?.property?.street
  const cityStateZip = address
    ? `${address.city}, ${address.state} ${address.zipcode}`.trim()
    : `${loanApplication?.property?.city}, ${loanApplication?.property?.state} ${loanApplication?.property?.zipcode}`.trim()

  return (
    <Vertical
      className={cn("border-b border-b-light-grey pb-2", className)}
      style={style}
    >
      <H5 color="white" className="text-center">
        {streetAddress}
      </H5>
      <Small color="white" className="text-center">
        {cityStateZip}
      </Small>
    </Vertical>
  )
}
